import { fetchAPI } from '@quickbit/backoffice-core-frontend';

export interface BackofficeUser {
  userId: string;
  email: string;
  createdBy: string | null;
  deletedAt: Date | null;
}

export const addBackofficeUser = (
  merchantId: string,
  email: string,
  createdBy: string
) =>
  fetchAPI<{ userId: string }>(`v1/merchants/${merchantId}/backoffice-users`, {
    method: 'POST',
    body: { email, createdBy },
  });

export const getBackofficeUsers = async (merchantId: string) => {
  const response = await fetchAPI<{ users: BackofficeUser[] }>(
    `v1/merchants/${merchantId}/backoffice-users`
  );
  const { users } = response;

  return users.map((user) => ({
    ...user,
    deletedAt: user.deletedAt ? new Date(user.deletedAt) : null,
  }));
};
